<template>
  <div>
    <!-- open modal -->
    <svg @click="medium = true" xmlns="http://www.w3.org/2000/svg" width="29.574" height="29.574" viewBox="0 0 29.574 29.574">
      <path id="Icon_material-add" data-name="Icon material-add" d="M37.074,24.4H24.4V37.074H20.175V24.4H7.5V20.175H20.175V7.5H24.4V20.175H37.074Z" transform="translate(-7.5 -7.5)"/>
    </svg>

    <div class="modal-teams" v-show="medium == true">
      <q-dialog v-model="medium">
        <q-card class="modal-teams">
          <q-card-section>
            <div class="text-h6">
              Add Team
              <!-- closeeeeee -->
              <svg @click="medium = false" xmlns="http://www.w3.org/2000/svg" width="15.26" height="15.26" viewBox="0 0 15.26 15.26">
                <path id="Icon_material-cancel" data-name="Icon material-cancel" d="M25.5,23.385,23.385,25.5,18,20.115,12.615,25.5,10.5,23.385,15.885,18,10.5,12.615,12.615,10.5,18,15.885,23.385,10.5,25.5,12.615,20.115,18Z" transform="matrix(1, -0.017, 0.017, 1, -10.682, -10.053)"/>
              </svg>
            </div>
          </q-card-section>

          <q-card-section>
            <q-card class="toggel" flat>
              <div class="">
                <div class="q-pa-md">
                  <div class="q-gutter-y-md">
                    <q-card flat>
<!--                      <div class="tabs-continer">-->
<!--                        <q-tabs v-model="tab" class="text-grey"  align="justify" narrow-indicator>-->
<!--                          <q-tab name="add-team" label="Add Team" />-->
<!--                          <q-tab name="add-member" label="Add Member" />-->
<!--                        </q-tabs>-->
<!--                      </div>-->
<!--                      <q-separator size="12" color="primary"></q-separator>-->

                      <q-tab-panels v-model="tab" animated>
                        <q-tab-panel name="add-team">
                          <add-team></add-team>
                        </q-tab-panel>

                        <q-tab-panel name="add-member">
                          <add-member></add-member>
                        </q-tab-panel>
                      </q-tab-panels>
                    </q-card>
                  </div>
                </div>
              </div>
            </q-card>
          </q-card-section>
        </q-card>
      </q-dialog>
    </div>
  </div>
</template>

<script>
import AddTeam from "@/components/user/Teams/AddTeam";
import AddMember from "@/components/user/Teams/AddMember";
export default {
  components: {AddMember, AddTeam},
  data: () => ({
    tab: 'add-team',
    medium: false,
    step: 1,
  }),
  methods: {
    next_step(e) {
      this.tab = e;
    }
  }
}
</script>

<style  scoped>

.the-button {
  margin-right: 22px;
}

.text-h6 {
  text-transform: uppercase;
  font-weight: 500;
}

.text-h6 svg {
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translate(0,-50%);
  cursor: pointer;
}

svg {
  fill: var(--mainColors);
}

.modal-teams {
  min-width: 826px;
  padding: 22px 66px 40px 75px;
  transition: 0.8s ease all;
}

 p.head {
  font-size: 28px;
  color: #1C2136;
  font-weight: bold;
}

 .q-card__section {
  padding: 0;
 }

.forms-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 26px;
}

.the-form .form-body form label {
  color: #707070!important;
  font-weight: bold;
}

.Icon_material-cancel {
  fill: var(--mainColors);
}

</style>